import { defineStore } from 'pinia'

export const useCommonStore = defineStore(
  'commonStore',
  () => {
    /* 公共图片展示页面 参数 */
    const commonPicturePresentationModel = ref({
      title: '',
      url: [],
      type: '',
    })

    const setCommonPicturePresentationModel = (model) => {
      commonPicturePresentationModel.value = model
    }

    /* 弹窗显示需要更新的协议数量 */
    const updateAgreementCount = ref(0)

    const setUpdateAgreementCount = (count: number) => {
      updateAgreementCount.value = count
    }

    /* 签收合同单据数据 */
    const signContractItem = ref(null)

    const setSignContractItem = (item) => {
      signContractItem.value = item
    }

    /* 寄快递 查快递 货运投保 我的保单 */
    const expressInsureActiveKey = ref('delivery')
    const setExpressInsureActiveKey = (key: string) => {
      expressInsureActiveKey.value = key
    }

    /* 货运投保页面 物流单号 */
    const insureExpressNo = ref('')
    const setInsureExpressNo = (key: string) => {
      insureExpressNo.value = key
    }
    return {
      commonPicturePresentationModel,
      updateAgreementCount,
      signContractItem,
      setCommonPicturePresentationModel,
      setUpdateAgreementCount,
      setSignContractItem,
      expressInsureActiveKey,
      setExpressInsureActiveKey,
      insureExpressNo,
      setInsureExpressNo,
    }
  },
  {
    persist: true,
  },
)
